import type { SecondaryMarketProduct, SecondaryMarketProductInternalUser } from './productSearch.model';

export function hasTradeAuthorisationFor(tradeAuthorisation: string | undefined, type: 'bid' | 'ask') {
  if (!hasTradeAuthorisation(tradeAuthorisation)) {
    return false;
  }

  if (tradeAuthorisation!.toLocaleLowerCase() === 'full') {
    return true;
  }

  switch (type) {
    case 'ask':
      return tradeAuthorisation!.toLocaleLowerCase() === 'ask only';
    case 'bid':
      return tradeAuthorisation!.toLocaleLowerCase() === 'bid only';
  }
}

export function hasTradeAuthorisation(tradeAuthorisation: string | undefined) {
  return tradeAuthorisation !== undefined && tradeAuthorisation.toLocaleLowerCase() !== 'off';
}

export const getRowIdFromSecondaryMarketProduct = (data: SecondaryMarketProduct) => {
  return data.rowId;
};

export const limitOrderEnabledByStatus = (product: SecondaryMarketProduct) => {
  const internalProduct = product as SecondaryMarketProductInternalUser;
  return internalProduct?.limitOrderStatus === true;
};

export const limitOrderEnabledByRtTradeAuthorisation = (product: SecondaryMarketProduct) => {
  const internalProduct = product as SecondaryMarketProductInternalUser;
  return internalProduct.rtTradeAuthorisation !== undefined && internalProduct.rtTradeAuthorisation !== 'Off';
};
